import React from 'react';

import { ApChip } from '@alixpartners/ui-components';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { DropdownItem } from 'components/NavFilter';
import { MONTH_NAMES, getYearByDate, getMonthByDate } from 'utils/date';
import {
	Wrapper,
	StyledMenu,
	OptionWrapper,
	OptionInfo,
	OptionLabel,
} from './PeriodSelect.styles';

const getPeriodString = ({ dateFrom, dateTo, year }) => {
	if (!year) {
		return `${MONTH_NAMES[getMonthByDate(dateFrom)]}${getYearByDate(dateFrom)
			.toString()
			.slice(-2)} - ${MONTH_NAMES[getMonthByDate(dateTo)]}${getYearByDate(
			dateTo
		)
			.toString()
			.slice(-2)}`;
	}

	return getMonthByDate(dateTo) - getMonthByDate(dateFrom) === 11
		? 'Full Year'
		: `${MONTH_NAMES[getMonthByDate(dateFrom)]} - ${
				MONTH_NAMES[getMonthByDate(dateTo)]
		  }`;
};

export class PeriodSelect extends React.Component {
	state = {
		isOpen: false,
	};

	componentDidMount() {
		const { data, dateRangeId } = this.props;
		const selectedRange = data.find(item => item.id.toString() === dateRangeId);

		if (!selectedRange) {
			this.redirectToDefaultRange();
		}
	}

	toggleMenu = isOpen => {
		this.setState({ isOpen });
	};

	handleChange = ({ id, dateFrom, dateTo }) => {
		const { setQueryStringStateAndPush } = this.props;

		setQueryStringStateAndPush({
			dateRangeId: id,
			dateFrom,
			dateTo,
		});
		this.setState({ isOpen: false });
	};

	redirectToDefaultRange = () => {
		const { data } = this.props;

		if (data.length === 0) {
			return;
		}

		this.handleChange(data[data.length - 1]);
	};

	render() {
		const { data, dateRangeId, disabled, order } = this.props;
		const { isOpen } = this.state;
		const selectedRange = data.find(item => item.id.toString() === dateRangeId);
		const chipLabel = selectedRange.year
			? selectedRange.year
			: `${getYearByDate(selectedRange.dateFrom)} - ${getYearByDate(
					selectedRange.dateTo
			  )}`;

		return (
			<StyledMenu
				disabled={disabled}
				button={
					<div style={{ width: 'fit-content', order }}>
						<ApChip small selected={isOpen}>
							{chipLabel}
						</ApChip>
					</div>
				}
				placement="bottom-end"
				toggleMenu={this.toggleMenu}
				isOpen={isOpen}
			>
				<Wrapper>
					{data.map((item, index) => (
						<DropdownItem
							{...item}
							key={index}
							onChange={this.handleChange}
							value={item}
							single
							selected={dateRangeId === String(item.id)}
						>
							<OptionWrapper>
								<OptionLabel>{item.name}</OptionLabel>
								<OptionInfo>{getPeriodString(item)}</OptionInfo>
							</OptionWrapper>
						</DropdownItem>
					))}
				</Wrapper>
			</StyledMenu>
		);
	}
}

export default props => (
	<SettingsOptionsContext.Consumer>
		{({ options }) => (
			<QueryStringContext.Consumer>
				{({ dateRangeId, setQueryStringStateAndPush }) => (
					<PeriodSelect
						{...props}
						data={options ? options.dateRanges : []}
						dateRangeId={dateRangeId}
						setQueryStringStateAndPush={setQueryStringStateAndPush}
					/>
				)}
			</QueryStringContext.Consumer>
		)}
	</SettingsOptionsContext.Consumer>
);
